var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import VizSensor from 'react-visibility-sensor';
import styled from 'styled-components';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 20px;\n"], ["\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 20px;\n"])));
export var ODListableAutoLoader = function (props) {
    var NoMoreComponent = props.noMoreComponent, LoadingComponent = props.loadingComponent, listableContext = props.listableContext, retryOnClick = props.retryOnClick;
    var _a = React.useContext(listableContext), _b = _a.state, loading = _b.loading, hasMore = _b.hasMore, totalCount = _b.totalCount, lastLoadErrorAt = _b.lastLoadErrorAt, loadMore = _a.loadMore;
    var _c = React.useState(false), isVisible = _c[0], setIsVisible = _c[1];
    var handleChange = function (isVisible) {
        setIsVisible(isVisible);
    };
    React.useEffect(function () {
        if (!loading && isVisible && hasMore) {
            if (lastLoadErrorAt <= 0) {
                loadMore();
            }
        }
    }, [isVisible, loading, loadMore, hasMore, lastLoadErrorAt]);
    return (React.createElement(VizSensor, { onChange: handleChange, partialVisibility: true },
        React.createElement(Wrapper, null,
            loading && LoadingComponent && React.createElement(LoadingComponent, null),
            !hasMore && totalCount > 0 && NoMoreComponent && retryOnClick && (React.createElement("div", { style: { width: '100%', cursor: 'pointer' }, onClick: function () {
                    console.log(49);
                    loadMore(true);
                } },
                React.createElement(NoMoreComponent, null))),
            !hasMore && totalCount > 0 && NoMoreComponent && !retryOnClick && React.createElement(NoMoreComponent, null))));
};
var templateObject_1;
//# sourceMappingURL=ODListableAutoLoader.js.map